import Joi from "joi";
import {
  AssetStatus,
  GoodProfileProductType,
  NewGoodProfileInput,
} from "../../../graphql/generated";
import customFieldSchema from "../../extensions/CustomFieldsForm/customFieldsSchema";
import documentSchema from "../../../utils/form/schemas/document.schema";

const goodProfileSchema = Joi.object<NewGoodProfileInput>({
  label: Joi.string().max(50).required().label("Label"),
  status: Joi.string()
    .valid(AssetStatus.Active, AssetStatus.Inactive)
    .allow(null)
    .label("Status"),
  code: Joi.string().label("License Number").allow(null, ""),
  unit: Joi.string().label("Unit").required(),
  productType: Joi.string()
    .valid(GoodProfileProductType.Heavy, GoodProfileProductType.Light)
    .allow(null)
    .label("Product Type"),
  weight: Joi.number().label("Weight Per Unit").required(),
  liquidGravity: Joi.number().label("Liquid Gravity").allow(null),
  supplierIds: Joi.array().items(Joi.string()).label("Suppliers").allow(null),
  shipperIds: Joi.array().items(Joi.string()).label("Shippers").allow(null),
  equivalences: Joi.array()
    .items(
      Joi.object({
        equivalentGoodId: Joi.string().required().messages({
          'string.empty':
            'When an Equivalence is selected, the Equivalent Commodity field cannot be blank. Please remove the equivalence record or add a commodity.',
          'any.required':
            'When an Equivalence is selected, the Equivalent Commodity field cannot be blank. Please remove the equivalence record or add a commodity.',
        }),
      }).unknown(true)
    )
    .label("Equivalences")
    .allow(null),
  restrictions: Joi.array().items(Joi.any()).label("Restrictions").allow(null),
  color: Joi.string().allow(null),
  goodProfileClassId: Joi.string().label("Class").allow(null),
  tags: Joi.array().items(Joi.string()).label("Tags").allow(null),
  customFields: Joi.array()
    .items(customFieldSchema)
    .label("Custom Fields")
    .allow(null),
  groupIds: Joi.array().items(Joi.string()).label("Group IDs").allow(null),
  documents: Joi.array().items(documentSchema).label("Documents").allow(null),
});

export default goodProfileSchema;
